"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setToast = exports.setIsDragActive = exports.addToast = exports.ToastType = void 0;
var typesafe_actions_1 = require("typesafe-actions");
var constants_1 = require("@app/shared/constants");
var ToastType;
(function (ToastType) {
    ToastType["FILE_SELECT_ADDED_FILES"] = "fileSelectAddedFiles";
    ToastType["REMOTE_SOURCE_LOAD_MORE"] = "remoteSourcesLoadMore";
})(ToastType = exports.ToastType || (exports.ToastType = {}));
var createAction = typesafe_actions_1.deprecated.createAction;
var toastTimers = {};
var addToast = function (type, message) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            dispatch(exports.setToast(type, message));
            if (toastTimers[type]) {
                clearTimeout(toastTimers[type]);
            }
            toastTimers[type] = setTimeout(function () {
                dispatch(exports.setToast(type, ''));
            }, Math.min(Math.max(message.length * 50, constants_1.MAX_TOAST_LIFETIME), constants_1.MIN_TOAST_LIFETIME));
            return [2 /*return*/];
        });
    }); };
};
exports.addToast = addToast;
exports.setIsDragActive = createAction('@@ui/SET_IS_DRAG_ACTIVE', function (resolve) { return function (isActive) { return resolve(isActive); }; });
exports.setToast = createAction('@@ui/SET_TOAST', function (resolve) { return function (type, message) { return resolve({ type: type, message: message }); }; });
